export default __webpack_public_path__ + "static/media/race-director-background.020b86f8.webp";